import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error('ErrorBoundary catch. Error: ', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      `ErrorBoundary catch. Error: ${error}, ErrorInfo: ${errorInfo}`,
    );
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      console.error('ErrorBoundary catch');
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
